import { Navigate } from "react-router-dom";
import { useBusiness } from "@/core/business";
import { PayrollRosterLoadingState } from "@/payroll/roster/payroll-roster-loading-state";
import { useCanViewPayrollRoster } from "@/payroll/roster/permissions";
import { useWorkbookAccessEditorAccess } from "@/payroll/workbook-access/permissions";
import { useGetMyUser } from "@/user/query";
import { payrollSettingsAccessPolicy } from "./access-policy";
import { PAYROLL_SETTINGS_ROSTER_PATH } from "./routes";

// Lands on the first payroll settings page this person can open. With neither
// permission the roster page still explains the denial.
const PayrollSettingsIndex = () => {
  const { selectedBusiness } = useBusiness();
  const { data: user } = useGetMyUser();
  const { canViewRoster, isLoading } = useCanViewPayrollRoster(
    selectedBusiness,
    user,
  );
  const { canManage: canManageAccess, isAccessLoading } =
    useWorkbookAccessEditorAccess(selectedBusiness?.id);

  if (isLoading || isAccessLoading) return <PayrollRosterLoadingState />;

  const { landing } = payrollSettingsAccessPolicy({
    canViewRoster,
    canManageAccess,
  });

  return <Navigate to={landing ?? PAYROLL_SETTINGS_ROSTER_PATH} replace />;
};

export default PayrollSettingsIndex;
